/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Feedback_Create_ErrorInputs */

const es_tools_nexata_feedback_create_error = /** @type {(inputs: Tools_Nexata_Feedback_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al registrar feedback`)
};

const en_tools_nexata_feedback_create_error = /** @type {(inputs: Tools_Nexata_Feedback_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error saving feedback`)
};

/**
* | output |
* | --- |
* | "Error saving feedback" |
*
* @param {Tools_Nexata_Feedback_Create_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_feedback_create_error = /** @type {((inputs?: Tools_Nexata_Feedback_Create_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Feedback_Create_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_feedback_create_error(inputs)
	return en_tools_nexata_feedback_create_error(inputs)
});
export { tools_nexata_feedback_create_error as "tools.nexata.feedback_create_error" }